import React, { useState, useEffect } from "react";
import Utils from "../utils/utils";
import { Link as RouterLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { PiEyeLight, PiEyeSlash } from "react-icons/pi";
import { TbCaretRightFilled } from "react-icons/tb";
import { useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
import { useToast } from "../components/ToastContext";

import "../App.css";
import "../css/Signin.css";

const CustomGoogleLoginButton = ({ onSuccess, onFailure }) => {
  const login = useGoogleLogin({
    onSuccess,
    onError: onFailure,
  });

  return (
    <button
      onClick={() => login()}
      style={{
        boxShadow: "0 -1px 0 rgba(0, 0, 0, .04), 0 1px 1px rgba(0, 0, 0, .25)",
      }}
      className="text-pink-800 font-semibold py-2 w-full px-4 rounded-md flex items-center justify-center transition duration-200 hover:bg-blue-50 hover:shadow-xl hover:text-pink-900 hover:z-50"
    >
      <img
        src="/images/google.png"
        alt="Google Icon"
        className="w-5 h-5 mr-4"
      />
      Continue with Google
    </button>
  );
};

const Signin = () => {
  const navigate = useNavigate();
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  const [showPassword, setShowPassword] = useState(false);
  const [formValue, setFormValue] = useState({
    email: "",
    password: "",
    role: "",
  });
  const showToast = useToast();

  const handleInput = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      const [isAdmin, email] = value.split("+");
      if (isAdmin === "admin") {
        setFormValue((prev) => ({ ...prev, email: email, role: "Admin" }));
      } else {
        setFormValue((prev) => ({ ...prev, email: value, role: "Student" }));
      }
    } else {
      setFormValue({ ...formValue, [name]: value });
    }
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    // Check Role
    const user = formValue.role === "Admin" ? "admin" : "students";
    try {
      let response = await fetch(`${SERVER_URL}/${user}/login`, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formValue),
      });
      if (response.ok) {
        response = await response.json();
        const user = {
          role: response.role,
          token: response.token,
          userId: response.userId,
          userName: response.userName,
        };

        Promise.all([Utils.setToken(user.token), Utils.setLoggedInUser(user)])
          .then(() => {
            showToast(response.message, "success", false, 3000);
            navigate("/"); // Redirect only after everything is stored
          })
          .catch((error) => {
            // console.error("Error setting user data:", error);
          });
      } else {
        if (response.status === 423) {
          navigate("/unauth");
          return;
        }
        response = await response.json();
        // console.log(response);
        showToast(response.message, "error", true, 5000);
      }
    } catch (error) {
      // console.error("Error:", error);
    }
  };

  const handleGoogleLoginSuccess = (response) => {
    axios
      .post(
        `${SERVER_URL}/google-login?access_token=${response.access_token}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${response.access_token}`,
            Accept: "application/json",
          },
        }
      )
      .then((res) => {
        const response = res.data;
        const user = {
          role: response.role,
          token: response.token,
          userId: response.userId,
          userName: response.userName,
        };

        Promise.all([Utils.setToken(user.token), Utils.setLoggedInUser(user)])
          .then(() => {
            showToast(response.message, "success", false, 3000);
            navigate("/"); // Redirect only after everything is stored
          })
          .catch((error) => {
            // console.error("Error setting user data:", error);
          });
      })
      .catch((error) => {
        const res = error.response;
        if (res.status === 423) {
          navigate("/unknown");
          return;
        }
        if (res.status === 403 && res.data.revoked) {
          navigate("/unauth");
          return;
        } else if (res.status === 403) {
          showToast(res.data.message, "error", true, 5000);
        } else {
          showToast(res.data.message, "error", true, 5000);
        }
      });
  };

  const handleGoogleLoginFailure = (error) => {
    showToast(error.message, "error", false, 5000);
    console.error("Login Failed:", error);
  };

  const scrollToDiv = (id) => {
    document.getElementById(id).scrollIntoView({
      behavior: "smooth",
    });
  };
  const text = "Aifinite Learning";
  const [displayText, setDisplayText] = useState(""); // Holds the current displayed text
  const [index, setIndex] = useState(0); // Tracks the current index of the text

  useEffect(() => {
    if (index < text.length) {
      const timeout = setTimeout(() => {
        setDisplayText((prev) => prev + text[index]);
        setIndex((prev) => prev + 1);
      }, 200);

      return () => clearTimeout(timeout);
    } else {
      const resetTimeout = setTimeout(() => {
        setDisplayText("");
        setIndex(0);
      }, 2000);

      return () => clearTimeout(resetTimeout);
    }
  }, [index, text]);
  return (
    <div
      className="min-h-screen bg-[#fff] flex flex-col items-center overflow-hidden"
      id="SignIn"
    >
      <div className="w-full max-w-7xl flex justify-between items-center py-2 px-6">
        <div className="w-[60px] md:ml-8 ">
          <img
            src="/images/logo.svg"
            alt="Aifinite Learning"
            className="w-full"
          />
        </div>
      </div>

      <div className="max-w-7xl mx-auto w-full flex flex-col md:flex-row items-center px-4 sm:px-6 md:px-12 py-6 space-y-6 md:space-y-0 md:space-x-6">
        <div className="flex-1 flex text-center md:text-left animate-fade-in flex-col gap-6 xs:gap-2">
          <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold leading-tight bg-gradient-to-r from-pink-800 to-violet-800 bg-clip-text text-transparent">
            Welcome to
          </h1>
          {/* <h1 className="">
            <span className="text-3xl sm:text-4xl md:text-6xl font-bold leading-[1.2] bg-gradient-to-r from-pink-900 via-[#7E1F80] to-pink-900 bg-clip-text text-transparent">
              Aifinite Learning
            </span>
          </h1> */}
          <div className="relative inline-block">
            <span className="text-3xl sm:text-4xl md:text-6xl font-bold leading-[1.2] bg-gradient-to-r from-pink-600 via-[#7E1F80] to-pink-900 bg-clip-text text-transparent">
              {displayText}
            </span>
            <span className="blinking-cursor">|</span>
          </div>
          <h2 className="text-xl sm:text-2xl md:text-4xl font-semibold  text-pink-800">
            Learning Management System
          </h2>
          <p className="text-lg md:text-xl">
            Start your journey of growth and achievement with powerful resources
            at your fingertips.
          </p>
          <button
            onClick={() => {
              scrollToDiv("LearnMoreDiv");
            }}
            className="flex items-center w-fit px-4 justify-start hover:px-6 py-3 bg-pink-800 tracking-[0.1rem] text-white font-semibold rounded-lg shadow-md bg-gradient-to-r from-pink-800 to-violet-800 hover:bg-pink-900 hover:tracking-[.2rem] transition-all duration-300 ease-in-out space-x-2"
          >
            <span>Learn More</span>
            <TbCaretRightFilled className="flex mt-1" />
          </button>
        </div>

        {/* Login Form */}
        <div className="flex-1 bg-white p-6 sm:p-8 w-full max-w-md rounded-lg animate-slide-in-right  shadow-[4px_4px_0px_#97266d,_0px_4px_12px_#97266d,_0px_8px_24px_#97266d]">
          <div className="flex justify-center mb-6">
            <p className="text-2xl md:text-3xl font-bold text-pink-800">
              Login
            </p>
          </div>
          <form onSubmit={handleSignIn} className="flex flex-col gap-6">
            <div className="relative w-full">
              <label className="form-control">
                <span className="label text-gray-700">Your Email</span>
                <input
                  required
                  type="email"
                  name="email"
                  placeholder="example@gmail.com"
                  className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  onChange={handleInput}
                />
              </label>
            </div>

            <div className="relative w-full">
              <label className="form-control">
                <span className="label text-gray-700">Your Password</span>
                <div className="relative w-full">
                  <input
                    required
                    name="password"
                    placeholder="********"
                    type={showPassword ? "text" : "password"}
                    onChange={handleInput}
                    className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <span
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <PiEyeSlash /> : <PiEyeLight />}
                  </span>
                </div>
              </label>
            </div>

            <div className="flex justify-end mb-6">
              <RouterLink to="/forget-password" fontSize="sm">
                <p className="text-pink-800 hover:underline">
                  Forgot your password?
                </p>
              </RouterLink>
            </div>

            <button className="rounded-lg tracking-[0.1rem] gap-[10px] text-white bg-pink-800 hover:bg-pink-900 uppercase cursor-pointer px-6 py-3 hover:tracking-[.2rem] transition-all duration-300 ease-in-out">
              Login
            </button>
          </form>

          <div className="flex mt-6">
            <p className="mr-2 text-gray-600">Don't have an account?</p>
            <RouterLink
              to="/signup"
              className="text-pink-800 underline font-semibold"
            >
              Sign up
            </RouterLink>
          </div>
          <div className="flex mt-6 justify-center">
            <CustomGoogleLoginButton
              onSuccess={handleGoogleLoginSuccess}
              onFailure={handleGoogleLoginFailure}
            />
          </div>
        </div>
      </div>

      <div className="container max-w-5xl mt-12 mx-auto" id="Details">
        <h2
          className="w-full my-2 text-3xl  sm:text-3xl md:text-5xl  font-bold leading-tight text-center
         opacity-0 translate-y-4 transition-all duration-700 ease-out animate-show"
        >
          <span className="bg-gradient-to-r from-pink-800 to-violet-800 bg-clip-text text-transparent">
            Your{" "}
          </span>
          <span className="bg-gradient-to-r from-pink-900 via-[#7E1F80] to-pink-900 bg-clip-text text-transparent">
            Partner in Learning{" "}
          </span>
          <span className="bg-gradient-to-r from-pink-800 to-violet-800 bg-clip-text text-transparent">
            Excellence
          </span>
        </h2>
        <div className="w-full mb-4">
          <div className="h-1 mx-auto bg-primary w-[40%] opacity-25 my-0 py-0 rounded"></div>
        </div>

        <div className="flex flex-wrap" id="LearnMoreDiv">
          <div className="w-5/6 sm:w-1/2 p-6 mt-20 xs:mt-10 animate-slide-in-left">
            <h3 className="text-3xl text-pink-800 font-bold leading-none mb-3">
              Transform the Way You Learn
            </h3>
            <p className="text-gray-600">
              Our state-of-the-art Learning Management System offers an
              intuitive platform designed to enhance collaboration, track
              progress, and deliver exceptional learning experiences. Customize,
              upload, and manage your content seamlessly to empower learners and
              drive results.
            </p>
          </div>
          <div className="w-full sm:w-1/2 p-6 animate-slide-in-right">
            <img
              className="h-6/6"
              src="/images/signinImg1.png"
              alt="A plug n play template"
            />
          </div>
        </div>
        <div className="flex flex-wrap flex-col-reverse sm:flex-row animate-slide-in-left">
          <div className="w-full sm:w-1/2 p-6">
            <img
              className="h-6/6"
              src="/images/signinImg2.png"
              alt="Make it your own!"
            />
          </div>
          <div className="w-full sm:w-1/2 p-6 mt-20 animate-slide-in-right">
            <div className="align-middle">
              <h3 className="text-3xl text-pink-800 font-bold leading-none mb-3">
                Empowering Education Through Innovation
              </h3>
              <p className="text-gray-600 mb-8">
                At Aifinite Learning, we’re redefining learning with our
                advanced Learning Management System. Designed to streamline
                education, enhance collaboration, and simplify content
                management, our LMS is the trusted solution for institutions and
                organizations striving for excellence.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-6xl w-full justify-evenly xs:m-5 flex flex-col md:flex-row items-center px-6 py-12 md:px-12  mt-8 mx-auto md:space-y-0 space-y-8 xs:space-y-2">
        <div className="w-fit animate-slide-in-left h-full">
          <h1 className="text-2xl sm:text-3xl md:text-5xl font-bold ">
            <span className="leading-tight bg-gradient-to-r from-pink-800 to-violet-800 bg-clip-text text-transparent">
              Ready to get started?
            </span>
          </h1>
        </div>

        <div className="flex justify-center space-x-6 p-8 xs:p-2 w-full max-w-md rounded-lg animate-slide-in-right">
          <a
            className="flex items-center justify-center px-4 py-2 hover:px-6 sm:py-3 text-sm hover:tracking-[0.1rem] sm:text-base bg-pink-800 text-white font-semibold rounded-lg shadow-md bg-gradient-to-r from-pink-800 to-violet-800 hover:bg-pink-900 transition-all duration-300 ease-in-out"
            href="https://aifinitelearning.com/"
          >
            <span>KNOW MORE</span>
            <TbCaretRightFilled className="text-lg ml-2" />
          </a>

          <a
            className="flex items-center justify-center px-4 py-2 hover:px-6 sm:py-3 text-sm sm:text-base leading-tight hover:tracking-[0.1rem]
             bg-gradient-to-r from-pink-800 to-violet-800 bg-clip-text text-transparent font-semibold rounded-lg shadow-md
              hover:bg-pink-900 transition-all duration-200 ease-in-out"
            href="https://aifinitelearning.com/#/landingpage"
          >
            <span>CONTACT US</span>
            <TbCaretRightFilled className="text-lg ml-2 text-pink-800" />
          </a>
        </div>
      </div>

      <div
        id="AboutSection"
        className="w-full bg-primary bg-opacity-5 py-12 px-4 sm:px-6 lg:px-12"
      >
        <div className="container mx-auto flex flex-col items-center justify-center">
          <div
            className="w-[65px] cursor-pointer"
            onClick={() => {
              scrollToDiv("SignIn");
            }}
          >
            <img
              src="/images/logo.svg"
              alt="Aifinite Learning"
              className="w-16 h-16"
            />
          </div>

          <div className="flex flex-wrap gap-8 items-center justify-center mt-4 text-center">
            <a
              href="https://aifinitelearning.com/#/terms"
              className="hover:text-pink-900 hover:font-semibold text-sm md:text-base cursor-pointer leading-4 text-pink-800 dark:text-pink-400 dark:hover:text-white"
            >
              Privacy Policy
            </a>
            <a
              href="https://aifinitelearning.com/#/terms"
              className="hover:text-pink-900 hover:font-semibold text-sm md:text-base cursor-pointer leading-4 text-pink-800 dark:text-pink-400 dark:hover:text-white"
            >
              Terms of Service
            </a>
            <a
              href="https://aifinitelearning.com/#/terms#sectioncookies"
              className="hover:text-pink-900 hover:font-semibold text-sm md:text-base cursor-pointer leading-4 text-pink-800 dark:text-pink-400 dark:hover:text-white"
            >
              Cookies Policy
            </a>
            <a
              href="https://aifinitelearning.com/#/terms#privacyrights"
              className="hover:text-pink-900 hover:font-semibold text-sm md:text-base cursor-pointer leading-4 text-pink-800 dark:text-pink-400 dark:hover:text-white"
            >
              Privacy Rights
            </a>
          </div>

          <div className="flex flex-wrap items-center gap-4 justify-center mt-6">
            <a
              aria-label="linkedin"
              href="https://www.linkedin.com/company/aifinite-learning/"
              target="_blank"
              rel="noreferrer"
              className="hover:fill-pink-900 fill-pink-700 dark:fill-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
              >
                <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"></path>
              </svg>
            </a>
            <a
              aria-label="instagram"
              href="https://www.instagram.com/aifinitelearning/"
              target="_blank"
              rel="noreferrer"
              className="hover:fill-pink-900 fill-pink-700 dark:fill-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="24"
                height="24"
                viewBox="0 0 50 50"
              >
                <path d="M 16 3 C 8.8324839 3 3 8.8324839 3 16 L 3 34 C 3 41.167516 8.8324839 47 16 47 L 34 47 C 41.167516 47 47 41.167516 47 34 L 47 16 C 47 8.8324839 41.167516 3 34 3 L 16 3 z M 16 5 L 34 5 C 40.086484 5 45 9.9135161 45 16 L 45 34 C 45 40.086484 40.086484 45 34 45 L 16 45 C 9.9135161 45 5 40.086484 5 34 L 5 16 C 5 9.9135161 9.9135161 5 16 5 z M 37 11 A 2 2 0 0 0 35 13 A 2 2 0 0 0 37 15 A 2 2 0 0 0 39 13 A 2 2 0 0 0 37 11 z M 25 14 C 18.936712 14 14 18.936712 14 25 C 14 31.063288 18.936712 36 25 36 C 31.063288 36 36 31.063288 36 25 C 36 18.936712 31.063288 14 25 14 z M 25 16 C 29.982407 16 34 20.017593 34 25 C 34 29.982407 29.982407 34 25 34 C 20.017593 34 16 29.982407 16 25 C 16 20.017593 20.017593 16 25 16 z"></path>
              </svg>
            </a>

            <a
              aria-label="facebook"
              href="https://www.facebook.com/profile.php?id=61554513943795"
              target="_blank"
              rel="noreferrer"
              className="hover:fill-pink-900 fill-pink-700 dark:fill-white"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                width="24"
                height="24"
                viewBox="0 0 50 50"
              >
                <path d="M 25 3 C 12.861562 3 3 12.861562 3 25 C 3 36.019135 11.127533 45.138355 21.712891 46.728516 L 22.861328 46.902344 L 22.861328 29.566406 L 17.664062 29.566406 L 17.664062 26.046875 L 22.861328 26.046875 L 22.861328 21.373047 C 22.861328 18.494965 23.551973 16.599417 24.695312 15.410156 C 25.838652 14.220896 27.528004 13.621094 29.878906 13.621094 C 31.758714 13.621094 32.490022 13.734993 33.185547 13.820312 L 33.185547 16.701172 L 30.738281 16.701172 C 29.349697 16.701172 28.210449 17.475903 27.619141 18.507812 C 27.027832 19.539724 26.84375 20.771816 26.84375 22.027344 L 26.84375 26.044922 L 32.966797 26.044922 L 32.421875 29.564453 L 26.84375 29.564453 L 26.84375 46.929688 L 27.978516 46.775391 C 38.71434 45.319366 47 36.126845 47 25 C 47 12.861562 37.138438 3 25 3 z M 25 5 C 36.057562 5 45 13.942438 45 25 C 45 34.729791 38.035799 42.731796 28.84375 44.533203 L 28.84375 31.564453 L 34.136719 31.564453 L 35.298828 24.044922 L 28.84375 24.044922 L 28.84375 22.027344 C 28.84375 20.989871 29.033574 20.060293 29.353516 19.501953 C 29.673457 18.943614 29.981865 18.701172 30.738281 18.701172 L 35.185547 18.701172 L 35.185547 12.009766 L 34.318359 11.892578 C 33.718567 11.811418 32.349197 11.621094 29.878906 11.621094 C 27.175808 11.621094 24.855567 12.357448 23.253906 14.023438 C 21.652246 15.689426 20.861328 18.170128 20.861328 21.373047 L 20.861328 24.046875 L 15.664062 24.046875 L 15.664062 31.566406 L 20.861328 31.566406 L 20.861328 44.470703 C 11.816995 42.554813 5 34.624447 5 25 C 5 13.942438 13.942438 5 25 5 z"></path>
              </svg>
            </a>
          </div>

          <p className="mt-6 text-xs sm:text-sm  text-pink-900 dark:text-gray-50 text-center">
            2024 @ Aifinite Learning Copyrights
          </p>
        </div>
      </div>
    </div>
  );
};

export default Signin;
